// A stable, anonymous per-browser visitor id + tiny beacon helpers. The id is a
// random uuid stored in localStorage — never derived from any personal data.
// Used for visit tracking and to de-duplicate partial-enquiry captures.

const KEY = "pm_visitor_id";

export function getVisitorId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto?.randomUUID?.() || `v_${Date.now()}_${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

function utmFromUrl() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      const v = p.get(k);
      if (v) utm[k] = v;
    });
    return Object.keys(utm).length ? utm : undefined;
  } catch {
    return undefined;
  }
}

// POST a small JSON body, using sendBeacon when possible so it survives the page
// unloading (exit intent / navigation away).
function post(path, body) {
  try {
    const payload = JSON.stringify(body);
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(path, blob);
      return;
    }
    fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* best effort */
  }
}

// Anonymous visit beacon (no PII).
export function trackVisit({ listingToken } = {}) {
  const visitor_id = getVisitorId();
  if (!visitor_id) return;
  post("/api/public/track", {
    visitor_id,
    listing_token: listingToken || null,
    path: window.location.pathname,
    referrer: document.referrer || null,
    utm: utmFromUrl() || null,
  });
}

// Soft-capture a half-filled enquiry form for a listing.
export function capturePartial(token, { name, phone, email }) {
  const visitor_id = getVisitorId();
  if (!visitor_id) return;
  // Only bother if there's at least a phone or email worth keeping.
  if (!String(phone || "").trim() && !String(email || "").trim()) return;
  post(`/api/public/listings/${token}/partial_enquiries`, {
    visitor_id,
    name: name || "",
    phone: phone || "",
    email: email || "",
    referrer: document.referrer || null,
    utm: utmFromUrl() || null,
  });
}
